module.exports = __webpack_public_path__ + "static/media/DSC_0100.c4b026ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0100.jpg
// module id = 591
// module chunks = 0